function About() {
    return (
      <section id="about" className="section">
        <h2>About Me</h2>
  
        <div className="about-content">
          <p>
            I am a Cloud Computing graduate currently rebuilding and improving my
            practical skills through hands-on projects. My main goal is to become
            a Junior DevOps or Cloud Engineer.
          </p>
  
          <p>
            I am focused on learning Linux, Git, Docker, cloud fundamentals,
            networking basics, and modern development workflows. This portfolio is
            part of my learning journey and shows the projects I am building step
            by step.
          </p>
  
          <p>
            I enjoy solving practical problems, learning by doing, and improving
            my technical knowledge through real projects.
          </p>
        </div>
      </section>
    );
  }
  
  export default About;